import React from "react";
import Row from "reactstrap/es/Row";
import Col from "reactstrap/es/Col";
import {Link} from "react-router-dom";
import Cookies from "universal-cookie";


class CookiePolicy extends React.Component
{
    constructor(props) {
        super(props);

        var is_cookie_accept = false;
        var form = "";

        const cookies = new Cookies();
        if( cookies.get('is_cookie_accept') === 'true' ) is_cookie_accept = true

        if(is_cookie_accept === false) {
            form = (
                <>
                    <div id={"cookie-accept-request"}>
                        <img class="spin-reverse" src={ require('assets/img/cookie_policy/badge_spinner.png') } />
                        <div className={"row"}>
                            <div className={"col-9"}>
                                <b>เว็บไซต์นี้ใช้คุกกี้!</b> เพื่อนำเสนอเนื้อหา
                                <br />ศึกษาเพิ่มเติมเกี่ยวกับ <Link to={"/th/cookie_policy"} target={"_blank"}>นโยบายคุกกี้</Link> <br />และ <Link to={"/th/privacy_policy"} target={"_blank"}>นโยบายความเป็นส่วนตัว</Link>
                            </div>
                            <div className={"col-3"}>
                                <a href="javascript:;" onClick={this.acceptClick} className={"accept-button"}>
                                    ยอมรับ
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* <div id={"cookie-accept-request"}>
                        <b>เราใช้คุกกี้!</b>&nbsp;&nbsp;
                        เว็บไซต์นี้มีการจัดเก็บคุกกี้เพื่อมอบประสบการณ์การใช้งานเว็บไซต์ของคุณให้ดียิ่งขึ้น
                        รวมถึงให้เราสามารถเลือกเนื้อหาที่เหมาะสมให้กับคุณอย่างเป็นส่วนตัว
                        ท่านสามารถศึกษา<Link to={"/th/privacy_policy"}>นโยบายความเป็นส่วนตัว</Link> ได้ที่ลิงค์นี้
                        การใช้งานเว็บไซต์นี้เป็นการยอมรับข้อกำหนดและยินยอมให้เราจัดเก็บคุ้กกี้ตามนโยบายที่แจ้งในเบื้องต้น
                        <br />
                        <Link onClick={this.acceptClick} className={"btn btn-default"}>ยอมรับ</Link>
                    </div> */}
                </>
            );
        } else {
            setTimeout(function() {
                var chatbox = document.getElementById('fb-customer-chat');
                chatbox.setAttribute("page_id", "88937699386");
                chatbox.setAttribute("attribution", "biz_inbox");
            }, 2000)
            console.log("User is already accept cookie policy.")
        }

        this.state = {
            is_cookie_accept: is_cookie_accept,
            form: form
        };

    }

    acceptClick = () => {
        const cookies = new Cookies()
        cookies.set('is_cookie_accept', 'true')
        this.setState({
            is_cookie_accept: true,
            form: ""
        })
        // TODO: Say Thank you to accept policy
    }

    render() {
        return (
            <>
                {this.state.form}
            </>
        );
    }

}

export default CookiePolicy;
